import type { SVGProps } from "react";

export function IconPurpleFastTime(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#FBF6FE" />
      <g clipPath="url(#clip0_8667_27161)">
        <path
          d="M14 22.6641H22.6667"
          stroke="#23232C"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M14 33.3359H22"
          stroke="#23232C"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <ellipse
          cx="31.33"
          cy="27.9978"
          rx="9.33333"
          ry="13.3333"
          transform="rotate(15 31.33 27.9978)"
          fill="#CEB8FF"
          stroke="#CEB8FF"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M33.2344 20.9141L30.9913 29.2854L33.2344 31.3307"
          stroke="#23232C"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M18 28H25.3333"
          stroke="#23232C"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_8667_27161">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
